// wrap-regex is disabled because it collides with our Prettier settings.
/* eslint-disable wrap-regex */

/**
 * Helps us find the correct URL prefix for making requests
 * @param {string} hostname Host name
 * @return {string} URL Prefix
 */
function getApiHostname(hostname: string = window.location.hostname): string {
  if (/(localhost|local\.)/.test(hostname)) {
    return 'http://localhost:3000';
  }

  let domainPrefix = '';

  if (/test\./.test(hostname)) {
    domainPrefix = 'test.';
  } else if (/qa\./.test(hostname)) {
    domainPrefix = 'qa.';
  }

  return `https://api.${domainPrefix}ramseysolutions.com`;
}

export { getApiHostname };
